var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDlpIndustry(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 4,
    fill: "#4D5BEC",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 15.5C13.3359 15.5 12 14.1641 12 12.5C12 10.8594 13.3359 9.5 15 9.5C16.6406 9.5 18 10.8594 18 12.5C18 14.1641 16.6406 15.5 15 15.5ZM17.1094 16.7422C18.9141 17.1641 20.25 18.7812 20.25 20.7031C20.25 21.1484 19.875 21.5 19.4297 21.5H10.5469C10.1016 21.5 9.75 21.1484 9.75 20.7031C9.75 18.7812 11.0625 17.1641 12.8672 16.7422L13.875 20.75L14.625 17.5625L13.875 16.25H16.125L15.375 17.5625L16.1016 20.75L17.1094 16.7422Z",
    fill: "#4D5BEC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDlpIndustry);
export default __webpack_public_path__ + "static/media/DlpIndustry.f9ccf48ff87b0d10122e0d686e4c88c2.svg";
export { ForwardRef as ReactComponent };